import React, { useEffect, useState } from 'react';
import VerificationPopup from '../modals/VerificationPopup';
import styles from '../../styles/newFeature.module.css';
import content from '../../language/ENGLISH.json'
import { HeroSection, MarqueeComponentHomePage, StackContainers, StackSkeleton } from '../qbStrap';
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import FAQ_mobile from '../Industry/FAQ_mobile';
import FrequentQuestions from '../homePage/FrequentQuestions';
import MobilePDBanner from '../common/MobilePDBanner';
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner';
import TestimonialSection from '../common/TestimonialSection';
import MobileTestimonialSection from '../common/MobileTestimonialSection';
import ThreeStepForm from '../common/ThreeStepForm';
import Image from 'next/image';
import OutletFeatures from '../common/OutletFeatures';
import { useRouter } from 'next/router';

const Bakers = () => {
    const { commonMarqueTitle } = getTitleContent();
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const [heroReadMore, setHeroReadMore] = useState(false);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const features = [
        {
            id: 1,
            image: "/assets/outlet/Bakers/rapid-billing.webp",
            tag: "Point Of Sale",
            icon: "/assets/groceries/kirana/POS.svg",
            title: "Rapid Billing",
            desc: "Tune into the ways of ultra-fast checkout with QueueBuster’s flexible and multiple payment-accepting billing process. Simplify bulk transactions and create part or split payment bills without a hassle. Take advantage of QB with:",
            tagColor: "#8AE4F6",
            bgColor: "#8ae4f626",
            stackColor1: "#D6F6FC",
            stackColor2: "#B0EFFC",
            stackColor3: "#8AE4F6",
            stackColor4: "#70D3E6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "10rem",
            meHeight: "28rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Lightning-fast checkout speed of less than 5 seconds
                </>,
                <>
                    Multiple batches of payments
                </>,
                <>
                    Generate multiple invoice types like proforma, credit, sales, and e-invoice.
                </>,
            ],
        },
        {
            id: 2,
            image: "/assets/outlet/Bakers/inventory.webp",
            tag: "Food Delivery Integration",
            icon: "/assets/outlet/iceCreamOutlet/foodDelivery.svg",
            title: "Online Food Ordering System",
            desc: "Extend your bakery's reach with QueueBuster's online delivery integration feature. It helps customers place orders directly on your food delivery marketplaces like zomato, swiggy. The automation of order placement, it increases sales. Manage orders efficiently from one screen for confirmation to delivery.",
            tagColor: "#FFBA00",
            bgColor: "#fff7e2",
            stackColor1: "#FEF8EB",
            stackColor2: "#FEEAC0",
            stackColor3: "#FFD579",
            stackColor4: "#FFC23E",
            sHeight: "10rem",
            eHeight: "26rem",
            msHeight: "15rem",
            meHeight: "41rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Seamless integration with your website to take orders online directly.
                </>,
                <>
                    Increase accuracy with reduced order errors through a system that directly synchronizes with your inventory.
                </>,
                <>
                    Enhance customer satisfaction with the convenience mode of order placements.
                </>,
            ],
        },
        {
            id: 3,
            image: "/assets/outlet/Bakers/vendor.webp",
            tag: "Daily Sales Report",
            icon: "/assets/outlet/iceCreamOutlet/report.svg",
            title: "Track Sales Margins",
            desc: "With QB's sales margin tracker feature, you can easily keep tabs on profit margins for every product. It provides you with fine details of your cost versus revenues, letting you know the most profitable products to vary their prices accordingly.",
            tagColor: "#EEC9FF",
            bgColor: "#fcf6ff",
            stackColor1: "#FCF7FF",
            stackColor2: "#F4E1FF",
            stackColor3: "#EEC9FF",
            stackColor4: "#E4ADFE",
            sHeight: "10rem",
            eHeight: "29rem",
            msHeight: "17rem",
            meHeight: "45rem",
            btnText: "Talk	to an expert",
            points: [
                <>
                    Create more than 80 different advanced reports regarding your sales margin to monitor profitability.
                </>,
                <>
                    Change your pricing strategy with real-time data to bring in extreme profits.
                </>,
                <>
                    Extract low-margin products and phase them out to minimize inventory.
                </>,
            ],
        },
        {
            id: 4,
            image: "/assets/outlet/Bakers/integrations.webp",
            tag: "Third-Party Integrations",
            icon: "/assets/outlet/iceCreamOutlet/integration_pos.svg",
            title: "Seamless Third-Party Integrations for Enhanced Efficiency",
            desc: "QB Bakery Billing Software comes with strong third-party API compatibility that will automatically get integrated into your POS. Be it accounting software, payment gateway, or even the delivery partners, QB assures to run smoothly at every place.",
            tagColor: "#4EEAC2",
            bgColor: "#e6fff9",
            stackColor1: "#C8F4E9",
            stackColor2: "#9EE9D6",
            stackColor3: "#4EEAC2",
            stackColor4: "#47DDB6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Easily integrate with popular accounting tools to automate your financial management.
                </>,
                <>
                    Connect with a variety of payment gateways for smoother and faster transactions.
                </>,
                <>
                    Integration with delivery partners for easy order fulfillment and tracking.
                </>,
            ],
        },
        {
            id: 5,
            image: "/assets/outlet/Bakers/reports.webp",
            tag: "Automated Financial Reporting",
            icon: "/assets/outlet/iceCreamOutlet/reportsIcon.svg",
            title: "Month/Year-End Automated Reporting",
            desc: "Track the financial health of your bakery; close your books at month or year-end and let QB do automatic reporting. It will let you automatically know your complete business position with all this information in no time.",
            tagColor: "#FFC3C3",
            bgColor: "#FFF3F3",
            stackColor1: "#FFF3F3",
            stackColor2: "#FFEBEB",
            stackColor3: "#FFDBDB",
            stackColor4: "#FFC3C3",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Automatic generation of financial statements at month/year-end
                </>,
                <>
                    It comes with detailed reporting on sales trends, expenses, and profit analysis.
                </>,
                <>
                    Saves you time and reduces manual reporting, so you have more time for your business.
                </>,
            ],
        },
        // {
        //     id: 6,
        //     image: "/assets/outlet/Bakers/barcode.webp",
        //     tag: "Reports",
        //     icon: "/assets/outlet/Bakers/reports_pos.svg",
        //     title: "Integrated Barcode Scanner",
        //     desc: "Add speed to your checkout counter with the built-in barcode scanner feature in QB. Through this software, you will have the ability to scan products into your system with the utmost rapidity. You can scan a long list of items within a very short period with appropriate billing, minimal errors, and fewer errors for a good customer experience. The scanner is directly synchronized with your inventory to give updates in real time.",
        //     tagColor: "#8AE4F6",
        //     bgColor: "#8ae4f626",
        //     stackColor1: "#D6F6FC",
        //     stackColor2: "#B0EFFC",
        //     stackColor3: "#8AE4F6",
        //     stackColor4: "#70D3E6",
        //     sHeight: "7rem",
        //     eHeight: "20rem",
        //     msHeight: "10rem",
        //     meHeight: "28rem",
        //     btnText: "Contact Sales",
        //     points: [
        //         <>
        //             Faster scanning of Products for Effective and Accurate Billing
        //         </>,
        //         <>
        //             Control Manual errors and increase Transaction Effectiveness
        //         </>,
        //         <>
        //             Automatically Synchronize with inventory to reflect real-time stock updates during billing.
        //         </>,
        //     ],
        // },
    ];

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    What makes QB Bakery Billing Software suitable for my small bakery business?
                </span>
            ),
            des: <>
                QB Bakery Billing Software is designed with simplicity and efficiency in mind, making it ideal for small bakery businesses. You don't need any technical expertise to manage your operations. The software automates billing, inventory management, and sales tracking, allowing you to focus on what you do best—baking. Additionally, the intuitive interface ensures that you can start using the software immediately after installation, with minimal training required.
                <ul>
                    <li>No technical skills needed to operate.</li>
                    <li>Streamlines daily operations, freeing up your time.</li>
                    <li>Provides tools for tracking sales, inventory, and customer orders in real-time.</li>
                </ul>
            </>,
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the online food ordering system in QB Bakery Billing Software work?
                </span>
            ),
            des: <>
                The online food ordering system in QB allows your customers to place orders directly through your website or app. The system integrates seamlessly with your existing digital platforms, synchronizing orders with your inventory and automating the entire order management process. From order confirmation to delivery, everything is handled from a single dashboard, reducing errors and improving efficiency.
                <ul>
                    <li>Direct integration with your website or mobile app.</li>
                    <li>Automated order management from start to finish.</li>
                    <li>Real-time synchronization with your inventory to prevent overbooking.</li>
                </ul>
            </>,
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can I track the profitability of individual products with QB?
                </span>
            ),
            des: <>
                Yes, QB Bakery Billing Software features a sales margin tracker that helps you monitor the profitability of each product you sell. The software generates detailed reports that compare costs against revenues, enabling you to identify your most and least profitable items. This data allows you to adjust your pricing strategies and optimize your inventory to maximize profits.
                <ul>
                    <li>Generate detailed reports on product profitability.</li>
                    <li>Adjust pricing based on real-time data insights.</li>
                    <li>Identify and phase out low-margin products to enhance overall profitability.</li>
                </ul>
            </>,
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How do third-party integrations benefit my bakery business with QB?
                </span>
            ),
            des: <>
                QB Bakery Billing Software supports powerful third-party integrations, allowing you to connect your POS system with various external platforms such as accounting software, payment gateways, and delivery services. These integrations streamline your business operations, ensuring that everything from financial management to customer payments and order fulfillment runs smoothly.
                <ul>
                    <li>Seamless integration with popular accounting software for automated bookkeeping.</li>
                    <li>Multiple payment gateway options for quicker, smoother transactions.</li>
                    <li>Direct connection with delivery partners for efficient order fulfillment.</li>
                </ul>
            </>,
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Is it easy to generate financial reports with QB Bakery Billing Software?
                </span>
            ),
            des: "QB simplifies financial reporting with its automated month/year-end reporting feature. At the end of each month or year, the software automatically generates comprehensive financial statements, including sales trends, expense reports, and profit analysis. These reports provide you with a clear understanding of your bakery’s financial health, helping you make informed business decisions.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the integrated barcode scanner improve the checkout process?
                </span>
            ),
            des: "The integrated barcode scanner in QB speeds up the checkout process by allowing you to quickly scan products for accurate billing. This feature reduces manual errors, enhances transaction speed, and ensures that your inventory is updated in real-time as each product is scanned. It’s an essential tool for busy bakeries where efficiency at the checkout counter is crucial.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can I customize the billing and invoicing process in QB?
                </span>
            ),
            des: "Yes, QB Bakery Billing Software offers customizable billing and invoicing options. You can tailor your invoices to reflect your brand by adding your logo, adjusting the layout, and including personalized messages. The software also supports digital invoices that can be sent directly to customers via email or WhatsApp, making the process more efficient and environmentally friendly.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QB help in managing multiple vendor relationships?
                </span>
            ),
            des: "QB includes a robust vendor management feature that allows you to easily track and manage your relationships with multiple suppliers. You can record purchases, track payments, and receive alerts for upcoming bills. This ensures that you maintain healthy relationships with your vendors and that your bakery is always well-stocked with the ingredients and supplies you need.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What support and training does QB provide for new users?
                </span>
            ),
            des: "QB offers comprehensive support and training to help new users get started. From installation to everyday use, the software comes with detailed guides, video tutorials, and a dedicated customer support team ready to assist you. Whether you need help setting up your system or troubleshooting an issue, QB ensures you have the resources needed to run your bakery smoothly.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How secure is the data stored in QB Bakery Billing Software?
                </span>
            ),
            des: "Data security is a top priority for QB. The software uses advanced encryption and secure cloud storage to protect your business information. Regular backups ensure that your data is safe from accidental loss, and strict access controls prevent unauthorized users from accessing sensitive information.",
            id: 10,
            activeIndex: 0,
        },
    ];

    return (
        <div>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/outlet/Bakers/mobile-hero-img.webp')" }}>
                        <div>
                            <h1>
                                <span>Billing Software for </span> <span></span>
                                <span>&nbsp; Bakery</span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>QueueBuster POS presents one of the most hassle-free bakery and general store management systems, specially designed for bakery shops, confectioneries, and coffee shops. Just install QB POS, and you are ready to take care of everything from rapid billing and advanced managerial controls to intelligent inventory management.
                            </p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn} onClick={() => router.push('/contact-form')}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 5rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/outlet/Bakers/hero-img.webp"
                            heading={<>Billing Software for </>}
                            staticHeading={<>Bakery</>}
                            description={"QueueBuster POS presents one of the most hassle-free bakery and general store management systems, specially designed for bakery shops, confectioneries, and coffee shops. Just install QB POS, and you are ready to take care of everything from rapid billing and advanced managerial controls to intelligent inventory management."}
                            solidBtnText={"Contact Sales"}
                            textContainerStyle={{ width: "50%" }}
                            setDemoModal={setDemoModal}
                        />
                    </div>
            }

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.features_section}>
                <div className={styles.section_heading}><h3>Best Features of Billing Software for Bakers and Confectioners</h3><div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <OutletFeatures features={features} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={Boolean(mobileView)} />
            </div>

            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ?
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={" Frequently Asked Questions for QB Bakery Billing Software"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={" Frequently Asked Questions for QB Bakery Billing Software"} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </div>
    )
}

export default Bakers